export class UnauthorizedError extends Error {}
export class ConflictError extends Error {}
export class GoneError extends Error {}

export const apiClient = {
  async get(url: string) {
    return await this.call(url, "GET");
  },

  async post(url: string, data?: object) {
    return await this.call(url, "POST", data);
  },

  async put(url: string, data: object) {
    return await this.call(url, "PUT", data);
  },

  async patch(url: string, data: object) {
    return await this.call(url, "PATCH", data);
  },

  async delete(url: string) {
    return await this.call(url, "DELETE");
  },

  async call(
    url: string,
    method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE",
    data?: object,
  ) {
    const body = data === undefined ? undefined : JSON.stringify(data);
    const response = await fetch(new URL(url, document.location.origin), {
      method,
      headers: { "Content-Type": "application/json" },
      body,
    });

    if (response.status === 404) return null;
    if (response.status === 401) throw new UnauthorizedError();
    if (response.status === 409) throw new ConflictError();
    if (response.status === 410) throw new GoneError();
    if (!response.ok) throw new Error("failed to fetch data");

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return await response.json();
    }
  },
};
